import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { Trans, useTranslation } from 'react-i18next';
// Components
import Box from '../shared/atoms/Box';
import Heading from '../shared/atoms/Heading';
import Line from '../shared/atoms/Line';
import Link from '../shared/atoms/Link';
import Alert from '../shared/molecules/Alert';
import ReferralRequest from './ReferralRequest';
import ShopItem from './ShopItem';
import HorsZone from './HorsZone';

const DisplayShop = ({
  shops,
  refs,
  indexShopClick,
  annuaire = false,
  horsZoneAnnuaire = false,
  ...rest
}) => {
  const { t } = useTranslation();
  const today = moment(new Date()).locale('en').format('ddd').toLowerCase();
  const isInZone = useSelector((state) => state.course.isInZone);

  // Porte d'entrée 2 : sur /reparation, hors zone, les cartes de l'annuaire.
  if (!isInZone && horsZoneAnnuaire) {
    return (
      <Box {...rest}>
        <HorsZone shops={shops} />
        <ReferralRequest />
      </Box>
    );
  }

  return (
    <Box mt={7} {...rest}>
      {!isInZone && (
        <Alert status="danger" mb={6} borderRadius="xs">
          {t('displayshop.texts.1')}
          <br />
          <Trans
            i18nKey="displayshop.texts.2"
            components={{
              annotation: <u />,
              url: (
                <Link
                  href={'https://www.roulezjeunesse.com/reparateur-a-domicile'}
                  color="primary.darkest"
                />
              ),
            }}
          />
          <br />- {t('displayshop.texts.3')}
        </Alert>
      )}
      <Box flexDirection="row">
        <Heading level={2}>
          {t('displayshop.texts.4', {
            count: shops.length,
          })}
        </Heading>
        <Line
          color="gray.main"
          property="solid"
          style={{ marginTop: '22px', marginLeft: '4px' }}
        />
      </Box>
      {shops.map((shop, index) => {
        return (
          <ShopItem
            key={index}
            shop={shop}
            index={index}
            annuaire={annuaire}
            today={today}
            indexShopClick={indexShopClick}
            refs={refs}
          />
        );
      })}
      <ReferralRequest />
    </Box>
  );
};

export default DisplayShop;
